/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { createContext, useEffect, useRef, useState } from "react";
import CartSection from "./Cart/CartSection";
import FamilyGroups from "./FamilyGroups/Index";
import FamilyGroupDetails from "./FamilyGroup/FamilyGroupDetails";
import apiGateWay from "../serviceHandler";
import Loader from "./Common/Loader";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "./Common/Modal";
import Swal from "sweetalert2";
// import createPostCheck from "./PaymentPage/PaymentResult";

export const AppContext = createContext();

const Index = () => {
  const urlParams = useParams();
  const myRef = useRef(null);
  const navigate = useNavigate();
  const tableData = JSON.parse(sessionStorage.getItem("urlParams"));

  useEffect(() => {
    if (Object.keys(urlParams).length) {
      sessionStorage.setItem("urlParams", JSON.stringify(urlParams));
    }
    if (!tableData) {
      navigate("/home");
    }

    getMenuData();
    getRvcList(); // ✅ This controls everything

  }, [urlParams]);

  const [menuData, setMenuData] = useState([]);
  const [filteredMenuData, setFilteredMenuData] = useState([]);
  const [loaderItems, setLoaderItems] = useState([]);
  const [cartItems, setCartItems] = useState(sessionStorage.getItem("cartData") ? JSON.parse(sessionStorage.getItem("cartData")) : []);
  const [selectedFamilyGroup, setSelectedFamilyGroup] = useState("");
  const [selectedFamilySubGroup, setSelectedFamilySubGroup] = useState("");
  const [searchText, setSearchText] = useState("");
  const [userFormData, setUserFormData] = useState({});
  const [guestData, setGuestData] = useState({});
  const [guestOrderData, setGuestOrderData] = useState({});
  const [toasterData, setToasterData] = useState({});
  const [showImage, setShowImage] = useState(false);
  const [viewOrders, setViewOrders] = useState(false);
  const [ordersList, setOrdersList] = useState([]);
  const [rvcList, setRvcList] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [rvcRoom, setrvcRoom] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [timeValid, setTimeValid] = useState({
    isServiveOpen: true,
    isModalOpen: false,
  });

  const [addCondimentsModal, setAddCondimentsModal] = useState({});

  useEffect(() => {
    if (toasterData.type) {
      setTimeout(() => {
        setToasterData({});
      }, 3000);
    }
  }, [toasterData]);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      if (!cartItems.length) {
        return;
      }
      e.returnValue = true;
    };
    if (!cartItems.length) {
      window.removeEventListener("beforeunload", handler);
    }
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [cartItems]);

  let temp = {};
  useEffect(() => {
    temp = userFormData;
  }, [userFormData]);

  const convertFrom24To12Format = (time24) => {
    const matchResult = time24.match(/([0-9]{1,2}):([0-9]{2})/);
    if (matchResult) {
      const [sHours, minutes] = matchResult.slice(1);
      const period = +sHours < 12 ? "AM" : "PM";
      const hours = +sHours % 12 || 12;
      return `${hours}:${minutes} ${period}`;
    }
  };

  const checkOperationalTimings = (rvcData = [], shouldModalOpen = false) => {
    const currentRvc = rvcData.find(rvc => rvc.code === Number(urlParams.rvc));
    if (!currentRvc) return;

    const { rvcStart_time, rvcStop_time } = currentRvc;
    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    const [startH, startM] = rvcStart_time.split(":").map(Number);
    const [endH, endM] = rvcStop_time.split(":").map(Number);

    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    let isActive;

    if (startMinutes <= endMinutes) {
      isActive = nowMinutes >= startMinutes && nowMinutes <= endMinutes;
    } else {
      isActive = nowMinutes >= startMinutes || nowMinutes <= endMinutes;
    }

    const inactiveStartTime = `${startH.toString().padStart(2, "0")}:${startM.toString().padStart(2, "0")}`;
    const inactiveEndTime = `${endH.toString().padStart(2, "0")}:${endM.toString().padStart(2, "0")}`;

    setTimeValid({
      isServiveOpen: isActive,
      isModalOpen: shouldModalOpen && !isActive,
      start: convertFrom24To12Format(inactiveStartTime),
      close: convertFrom24To12Format(inactiveEndTime),
    });
  };

  const executeScroll = () => {
    myRef.current.scrollIntoView();
  };

  const searchItem = () => {
    if (!searchText.trim().length) {
      getMenuData();
      return false;
    }
    try {
      const tempMenuData = new Array(...menuData);
      const searchedList = tempMenuData
        .map(({ familyGroup, ...mListItem }) => {
          return {
            ...mListItem,
            familyGroup: familyGroup.map(({ menuItem, ...fg }) => {
              return {
                ...fg,
                menuItem: menuItem.filter((mItem) =>
                  mItem.name.toLowerCase().includes(searchText.toLowerCase()),
                ),
              };
            }),
          };
        })
        .filter(
          (mi) =>
            mi.familyGroup.filter((fg) => fg.menuItem.length > 0).length > 0,
        );
      setFilteredMenuData(searchedList);
    } catch (error) {
      setFilteredMenuData(menuData);
      console.log(`searchItem error`, error);
    }
  };

  const handleLoader = (items, action) => {
    switch (action) {
      case "add":
        setLoaderItems([...loaderItems, ...items]);
        break;
      case "remove":
        setLoaderItems(loaderItems.filter((item) => !items.includes(item)));
        break;
      default:
        break;
    }
  };

  // Add the updateNIPaymentOrderStatus function
  const updateNIPaymentOrderStatus = async (paymentStatus, responseData = {}) => {
    try {
      const orderReference = sessionStorage.getItem("orderReference");
      const orderId = JSON.parse(sessionStorage.getItem("orderId"));

      const checkSummary = responseData?.result?.checkSummary || {};

      const payload = {
        OrderId: orderId,
        OrderReference: orderReference,
        CheckNumber: checkSummary.checkNumber,
        CheckSequenceNumber: checkSummary.checkSequenceNumber,
        CheckDate: responseData?.result?.orderPosted_Time || new Date().toISOString(),
        POSCheckStatus: paymentStatus,
      };

      console.log("🔹 UpdateNIPaymentOrderStatus payload:", payload);

      const response = await apiGateWay.post(
        "/keyconnect/simphony/UpdateNIPaymentOrderStatus",
        payload
      );

      if (response.status === 200) {
        console.log("✅ UpdateNIPaymentOrderStatus success:", response.data);
        return response.data;
      } else {
        console.warn("⚠️ UpdateNIPaymentOrderStatus failed:", response.status, response.data);
        return null;
      }
    } catch (error) {
      console.error("❌ Error calling UpdateNIPaymentOrderStatus:", error);
      return null;
    }
  };

  const createPostCheck = async (result) => {
    if (result.isConfirmed) {
      try {
        const rawCheckData = sessionStorage.getItem("checkData");
        const generalComment = sessionStorage.getItem("generalComment");
        const orderType = sessionStorage.getItem("orderType");

        if (!rawCheckData) throw new Error("No check data found");

        const postBody = {
          ...JSON.parse(rawCheckData),
          Guest_count: 1,
        };

        if (generalComment) {
          postBody.GuestRemarks = JSON.parse(generalComment);
        }

        const postResponse = await apiGateWay.post("keyconnect/simphony/PostCheck", postBody);

        if (postResponse.status === 200) {
          if (orderType !== "room_posting") {
            await updateNIPaymentOrderStatus("Posted", postResponse.data);
          }

          Swal.fire({
            title: "Order Placed",
            text: orderType === "room_posting"
              ? "Your order has been placed successfully. Estimated delivery time is approximately 25-30 minutes. Kindly settle your bill with our service team upon delivery."
              : "Your order has been placed successfully. Estimated delivery time is approximately 45 minutes and may vary depending on order volume. Kindly settle your bill with our service team upon delivery.",
            icon: "success",
            confirmButtonColor: "#0f145b",
          }).then((result) => {
            if (result.isConfirmed) {
              sessionStorage.removeItem("cartData");
              setCartItems([]);
              navigate('/home');
            }
          });
        } else {
          if (orderType !== "room_posting") {
            await updateNIPaymentOrderStatus("Failed", postResponse.data);
          }

          Swal.fire({
            title: "Order Failed",
            text: "We couldn’t place your order at this time. Please try again or contact our staff for assistance.",
            icon: "error",
          }).then((result) => {
            if (result.isConfirmed) {
              const urlData = JSON.parse(sessionStorage.getItem("urlParams"));
              const orderType = sessionStorage.getItem("orderType");
              if (orderType !== "room_posting") {
                navigate('/ezmenu/' + urlData?.tableNumer + '/' + urlData?.rvc + '/' + urlData?.zone + '/' + urlData?.actualTableNumber);
              }
            }
          });
        }
      } catch (error) {
        console.error("createPostCheck error:", error);
        const orderType = sessionStorage.getItem("orderType");

        if (orderType !== "room_posting") {
          await updateNIPaymentOrderStatus("Failed", error?.response?.data || {});
        }

        Swal.fire({
          title: "Order Failed",
          text: "We couldn’t place your order at this time. Please try again or contact our staff for assistance.",
          icon: "error",
        }).then((result) => {
          if (result.isConfirmed) {
            const urlData = JSON.parse(sessionStorage.getItem("urlParams"));
            const orderType = sessionStorage.getItem("orderType");
            if (orderType !== "room_posting") {
              navigate('/ezmenu/' + urlData?.tableNumer + '/' + urlData?.rvc + '/' + urlData?.zone + '/' + urlData?.actualTableNumber);
            }
          }
        });
      }
    }
  };

  const getMenuData = async () => {
    let rvcnumber = Number(urlParams.rvc);
    let zone = Number(urlParams.zone);
    let tableNumer = Number(urlParams.tableNumer);
    try {
      handleLoader(["getMenuData"], "add");
      const response = await apiGateWay.get(
        `/keyconnect/simphony/GetMenuItems?LocationId=${tableNumer}&Zone=${zone}&RvcCode=${rvcnumber}`,
      );
      handleLoader(["getMenuData"], "remove");
      if (response.status === 200) {
        setMenuData(response?.data?.result?.data || []);
        setFilteredMenuData(response?.data?.result?.data || []);
      } else {
        setMenuData([]);
        setFilteredMenuData([]);
      }
    } catch (error) {
      setMenuData([]);
      setFilteredMenuData([]);
      handleLoader(["getMenuData"], "remove");
      console.log(`getMenuData error`, error);
    }
  };

const getOrderTypes = async () => {
  try {
    handleLoader(["getOrderTypes"], "add");

    const response = await apiGateWay.get(
      `/keyconnect/simphony/GetOrderType?locationid=${urlParams.tableNumer}&revenuecenterObjectNum=${urlParams.rvc}`,
    );
    console.log("GetOrderType API full response:", response);
    console.log("GetOrderType API data:", response?.data);

    handleLoader(["getOrderTypes"], "remove");

    if (response.status === 200) {
      const types = response?.data?.result?.data || [];

      console.log("✅ Order Types:", types);

      setOrderTypes(types);
      sessionStorage.setItem("orderTypes", JSON.stringify(types));

      return types;
    }

    return [];
  } catch (error) {
    handleLoader(["getOrderTypes"], "remove");
    console.error("❌ GetOrderType API error:", error);
    return [];
  }
};
  // Function to select order type based on RVC type using the actual order types data
const selectOrderTypeByRvcType = (rvcType, types) => {
  if (!types.length) return;

  const orderType = sessionStorage.getItem("orderType");
  let selectedType = null;

  // Use the session storage orderType if available (room_posting or online_payment)
  if (orderType === "room_posting") {
    selectedType = types.find((t) => t.identifier === "RP");
  } else if (orderType === "online_payment") {
    selectedType = types.find((t) => t.identifier === "DI");
  }

  // Fallback to rvcType logic if orderType is not set
  if (!selectedType) {
    if (rvcType === "ROOMS") {
      selectedType = types.find((t) => t.identifier === "RP");
    } else {
      selectedType = types.find((t) => t.identifier === "DI");
    }
  }

  // Final fallback
  if (!selectedType) {
    selectedType = types[0];
  }

  console.log("✅ Selected Order Type:", selectedType);

  sessionStorage.setItem("CheckOrderType", selectedType.itemCode);
  sessionStorage.setItem("orderTypeCode", selectedType.identifier);
  sessionStorage.setItem("orderTypeName", selectedType.name);

  setSelectedOrderType(selectedType);
};

 const getRvcList = async () => {
  try {
    handleLoader(["getRvcList"], "add");

    const response = await apiGateWay.get("/keyconnect/simphony/GetRVCs");

    handleLoader(["getRvcList"], "remove");

    if (response.status === 200) {
      const allRvcData = response?.data?.result?.data || [];

      const data = allRvcData.filter(
        (item) => item?.code == urlParams.rvc
      );

      console.log("✅ RVC DATA:", data);

      setRvcList(data);

      if (data.length > 0) {

        // Room logic
        if (data[0].type === "ROOMS") {
          setrvcRoom({
            status: true,
            number: urlParams.tableNumer,
          });
        }

        // ✅ FETCH ORDER TYPES AFTER RVC
        const types = await getOrderTypes();

        // ✅ SELECT ORDER TYPE AFTER BOTH AVAILABLE
        if (types.length > 0) {
          selectOrderTypeByRvcType(data[0].type, types);
        }

      } else {
        console.error("❌ Invalid RVC");
      }

      setTimeout(() => {
        checkOperationalTimings(allRvcData, true);
      }, 1000);
    }
  } catch (error) {
    handleLoader(["getRvcList"], "remove");
    console.error("❌ getRvcList error:", error);
  }
};

  const addGuest = async (data, type) => {
    try {
      handleLoader(["addGuest"], "add");

      const guestPayload = {
        FirstName: data.FirstName,
        LastName: data.LastName,
        MobileNumber: data.MobileNumber,
        HotelId: type === "payNow" ? 0 : data.HotelId,
        HotelRoomNumber: type === "payNow" ? "" : data.HotelRoomNumber,
        RoomNumber: data.RoomNumber,
      };

      console.log("Sending guest payload to API:", guestPayload);

      const response = await apiGateWay.post(
        "/keyconnect/simphony/AddGuests",
        guestPayload,
      );

      handleLoader(["addGuest"], "remove");

      if (response.status === 200) {
        setGuestData(response?.data?.result[0] || {});
        createGuestOrder({
          guest: response?.data?.result[0] || {},
          checkname: data.checkname,
          guestCount: 1,
          hotelRoomNumber: data.HotelRoomNumber,
          hotelId: data.HotelId,
          hotelName: data.HotelName,
        }, type);
      } else {
        setGuestData({});
      }
    } catch (error) {
      setGuestData({});
      handleLoader(["addGuest"], "remove");
      console.log(`addGuest error`, error);

      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.description || "Failed to add guest. Please try again.",
        icon: "error",
      });
    }
  };

  const createGuestOrder = async ({
    guest,
    checkname,
    guestCount,
    roomNumber,
    hotelId,
    hotelName,
    hotelRoomNumber,
  }, type) => {
    if (!guest.id) return;
    const body = {
      Guest_Id: guest.id,
      TableNumber: Number(urlParams.actualTableNumber),
      CurrentlyOccupied: Number(guestCount),
      LocationID: Number(urlParams.tableNumer),
      RvcID: Number(urlParams.rvc),
    };
    try {
      handleLoader(["createGuestOrder"], "add");
      const response = await apiGateWay.post(
        "/keyconnect/simphony/CreateGuestOrder",
        body,
      );
      handleLoader(["createGuestOrder"], "remove");
      if (response.status === 200) {
        setGuestOrderData(response?.data?.result[0] || {});
        proceedToCheckout({
          guest: { ...guest, checkname, guestCount, roomNumber, hotelId, hotelName, hotelRoomNumber },
          guestOrder: response?.data?.result[0] || {},
        }, type);
      } else {
        setGuestOrderData([]);
      }
    } catch (error) {
      setGuestOrderData([]);
      handleLoader(["createGuestOrder"], "remove");
      console.log(`createGuestOrder error`, error);
    }
  };

  const resetAppData = () => {
    getMenuData();
    setCartItems([]);
    setSelectedFamilyGroup("");
    setSelectedFamilySubGroup("");
    setSearchText("");
    setUserFormData({});
    setGuestData({});
    setGuestOrderData({});
    setToasterData({});
  };

const proceedToCheckout = async ({ guest, guestOrder }, type) => {

  let checkOrderType = sessionStorage.getItem("CheckOrderType");
  let orderTypeCode = sessionStorage.getItem("orderTypeCode");

  // Fallback to state if session storage is empty
  if (!checkOrderType && selectedOrderType) {
    checkOrderType = selectedOrderType.itemCode;
    orderTypeCode = selectedOrderType.identifier;
  }

  if (!checkOrderType) {
    console.error("❌ CheckOrderType missing");
    Swal.fire({
      title: "Error",
      text: "Order type not set",
      icon: "error",
    });
    return;
  }

  const parsedCheckOrderType = parseInt(checkOrderType);
  
  // Get GuestRemarks from session storage (if any)
  const generalComment = sessionStorage.getItem("generalComment");
  let guestRemarks = "";
  
  if (generalComment) {
    try {
      const parsedComment = JSON.parse(generalComment);
      
      // Handle different possible data structures
      if (Array.isArray(parsedComment)) {
        // If it's an array of remarks, combine them
        guestRemarks = parsedComment
          .filter(remark => remark && remark.text && remark.text.trim())
          .map(remark => remark.text)
          .join(" | ");
      } else if (typeof parsedComment === 'string') {
        // If it's a direct string
        guestRemarks = parsedComment;
      } else if (parsedComment && parsedComment.text) {
        // If it's a single object with text property
        guestRemarks = parsedComment.text;
      } else if (parsedComment && typeof parsedComment === 'object') {
        // If it's an object with multiple properties, try to get the remark
        guestRemarks = parsedComment.remark || parsedComment.comment || parsedComment.message || "";
      }
      
      console.log("Guest Remarks:", guestRemarks);
    } catch (error) {
      console.error("Error parsing generalComment:", error);
      // If parsing fails, try to use it as a string directly
      guestRemarks = generalComment;
    }
  }

  const getTotalAmount = (item) => {
    let sum = 0;
    if (item) {
      cartItems.forEach((it) => {
        if (it.itemCode === item.itemCode) {
          sum = sum + Number(it.quantity) * Number(it.price);
          if (it.condiments) {
            it.condiments.forEach((cond) => {
              sum += Number(cond.quantity) * Number(cond.condimentMenuItemPrice || 0);
            });
          }
        }
      });
    } else {
      cartItems.forEach((it) => {
        sum = sum + Number(it.quantity) * Number(it.price);
        if (it.condiments) {
          it.condiments.forEach((cond) => {
            sum += Number(cond.quantity) * Number(cond.condimentMenuItemPrice || 0);
          });
        }
      });
    }
    return (Math.round(sum * 100) / 100).toFixed(2);
  };

  const calculatedTotal = getTotalAmount();

  const postBody = {
    TableNumber: Number(urlParams.actualTableNumber),
    RevenueCenterObjectNum: Number(urlParams.rvc),
    OrderNumber: Number(guestOrder.orderNo),
    CheckOrderType: parsedCheckOrderType, // This is for PostCheck API
    isPaymentCompleted: true,
    Guest_count: 1,
    checkname: "EzMenu Guest",
    LocationID: parseInt(rvcList[0]?.location_Id),
    isEwallet: false,
    TenderMedia: {
      Code: 1,
      Name: "",
      Amount: calculatedTotal,
    },
    MenuItems: cartItems?.map((item) => {
      return {
        itemCode: item.itemCode,
        Price: item.price,
        quantity: item.quantity,
        Comment: item.comment,
        Condiments: item?.condiments
          ?.filter((x) => x.quantity > 0)
          .map((cond) => {
            return {
              ItemCode: cond.itemCode || cond.condimentMenuItemId,
              Price: cond.condimentMenuItemPrice || 0,
              quantity: cond.quantity,
            };
          }),
      };
    }),
  };
  
  // Prepare the body for AddOrderItem API - Use OrderTypeObjNum instead of CheckOrderType
  const body = {
    TableNumber: Number(urlParams.actualTableNumber),
    RevenueCenterObjectNum: Number(urlParams.rvc),
    OrderNumber: Number(guestOrder.orderNo),
    OrderTypeObjNum: parsedCheckOrderType, // ✅ Changed from CheckOrderType to OrderTypeObjNum
    OrderType: "New Check",
    Guest_count: 1,
    checkname: "EzMenu Guest",
    LocationID: parseInt(rvcList[0]?.location_Id),
    // Add GuestRemarks as a separate root-level field if it exists
    ...(guestRemarks && guestRemarks.trim() && { GuestRemarks: guestRemarks }),
    orderMenuItems: cartItems?.map((item) => {
      return {
        itemCode: item.itemCode,
        Price: item.price,
        quantity: item.quantity,
        Comment: item.comment,
        Condiments: item?.condiments
          ?.filter((x) => x.quantity > 0)
          .map((cond) => {
            return {
              ItemCode: cond.itemCode || cond.condimentMenuItemId,
              Price: cond.condimentMenuItemPrice || 0,
              quantity: cond.quantity,
            };
          }),
      };
    }),
  };

  console.log("📦 AddOrderItem payload (using OrderTypeObjNum):", body);
  console.log("💰 Total amount with condiments:", calculatedTotal);

  try {
    handleLoader(["proceedToCheckout"], "add");
    const response = await apiGateWay.post(
      "/keyconnect/simphony/AddOrderItem",
      body,
    );
    handleLoader(["proceedToCheckout"], "remove");
    
    resetAppData();
    
    if (response.status == 200) {
      sessionStorage.setItem("checkData", JSON.stringify(postBody));
      sessionStorage.setItem("orderId", JSON.stringify(response.data.message.orderId));
      if (type == "payNow") {
        navigate("/ezmenu/payment", {
          state: {
            amount: calculatedTotal,
            orderId: response.data.message.orderId,
            currency: "SAR",
          },
        });
      } else {
        const orderType = sessionStorage.getItem("orderType");
        if (orderType === "room_posting") {
          Swal.fire({
            title: "Order Placed",
            text: response.data.message.message || "Your order has been placed successfully. Estimated delivery time is approximately 25-30 minutes. Kindly settle your bill with our service team upon delivery.",
            icon: "success",
            confirmButtonColor: "#0f145b",
          }).then((result) => {
            if (result.isConfirmed) {
              sessionStorage.removeItem("cartData");
              setCartItems([]);
              navigate('/home');
            }
          });
        } else {
          createPostCheck({ isConfirmed: true });
        }
      }
      setIsChecked(false);
    } else {
      Swal.fire({
        title: "Error!",
        text: "Failed to place your order!",
        icon: "error",
      });
      setIsChecked(false);
    }
  } catch (error) {
    resetAppData();
    handleLoader(["proceedToCheckout"], "remove");

    Swal.fire({
      title: "Error!",
      text: "Failed to place your order!",
      icon: "error",
    });
    console.log(`proceedToCheckout error`, error);
  }
};
  useEffect(() => {
    searchItem();
  }, [searchText]);

  const handleCartActions = (action, item) => {
    const { itemCode } = item;
    const index = cartItems.findIndex((e) => e.itemCode === itemCode);

    if (index === -1) return;

    const updatedCartItem = {
      ...cartItems[index],
    };

    switch (action) {
      case "increment":
        const incrementedItem = {
          ...updatedCartItem,
          quantity: updatedCartItem.quantity + 1,
        };
        setCartItems([
          ...cartItems.slice(0, index),
          incrementedItem,
          ...cartItems.slice(index + 1),
        ]);
        break;

      case "decrement":
        if (updatedCartItem.quantity === 1) {
          handleCartActions("remove", updatedCartItem);
        } else {
          const decrementedItem = {
            ...updatedCartItem,
            quantity: updatedCartItem.quantity - 1,
          };

          const updatedCondimentsForDecrement =
            decrementedItem.condiments?.map((condiment) => ({
              ...condiment,
              quantity:
                condiment.quantity === updatedCartItem.quantity
                  ? condiment.quantity
                  : condiment.quantity,
            })) || null;

          setCartItems([
            ...cartItems.slice(0, index),
            { ...decrementedItem, condiments: updatedCondimentsForDecrement },
            ...cartItems.slice(index + 1),
          ]);
        }
        break;

      case "remove":
        setCartItems([
          ...cartItems.slice(0, index),
          ...cartItems.slice(index + 1),
        ]);
        break;

      default:
        break;
    }
  };

  const getTotal = () => {
    let sum = 0;
    cartItems.forEach((it) => (sum = sum + Number(it.quantity)));
    return sum;
  };

  // Get the current order type display
  const getCurrentOrderTypeDisplay = () => {
    const code = sessionStorage.getItem("orderTypeCode");
    const name = sessionStorage.getItem("orderTypeName");
    if (code === "RP") return `Room Posting (RP)`;
    if (code === "DI") return `Dine In/Card Payment (DI)`;
    return name ? `${name} (${code})` : "Unknown";
  };

  const appStoreData = {
    menuData,
    filteredMenuData,
    cartItems,
    selectedFamilyGroup,
    selectedFamilySubGroup,
    searchText,
    rvcList: rvcList || [],
    orderTypes,
    selectedOrderType,
    timeValid,
    setTimeValid,
    setShowImage,
    setSearchText,
    setSelectedFamilyGroup,
    setSelectedFamilySubGroup,
    setCartItems,
    handleCartActions,
    proceedToCheckout,
    addGuest,
    setUserFormData,
    addCondimentsModal,
    setAddCondimentsModal,
    isChecked,
    setIsChecked,
    getCurrentOrderTypeDisplay,
  };

  const getTotalOrderPrice = () => {
    const price = ordersList.reduce((a, b) => a + b.price, 0);
    return Number(price).toFixed(2);
  };

  const renderViewOrderModal = () => {
    return (
      <div className="p-3">
        <div className="pt-2 pb-1 px-2">
          {ordersList?.length ? (
            <div className="mb-2 flex-column added-item no-border">
              <div className="row d-flex align-items-center">
                <table>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordersList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td style={{ textAlign: "right" }}>
                            {item.quantity ? Number(item.quantity).toFixed(2) : 0}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td />
                      <td style={{ textAlign: "right" }}>
                        Sum: {<b>AED {getTotalOrderPrice()}</b>}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center">
              No orders are placed so far
            </div>
          )}
        </div>
      </div>
    );
  };

  const viewOrder = async () => {
    setViewOrders(true);
    try {
      const params = {
        LocationID: 1,
        TableNumber: Number(urlParams.tableNumer),
        RevenueCenterObjectNum: Number(urlParams.rvc),
        MobileNumber: Number(tableData.MobileNumber),
      };
      handleLoader(["viewOrder"], "add");
      const response = await apiGateWay.get(
        `/keyconnect/simphony/ViewOrders?${new URLSearchParams(params)}`,
      );
      const resultList = response.data.result;
      let temp = [];
      resultList.forEach((item) => {
        temp = [...temp, ...item.orderMenuItems];
      });
      handleLoader(["viewOrder"], "remove");
      if (response.status === 200) {
        setOrdersList(temp);
      }
    } catch (error) {
      handleLoader(["viewOrder"], "remove");
      console.log(`viewOrder error`, error);
    }
  };

  return (
    <AppContext.Provider value={appStoreData}>

      {viewOrders ? (
        <Modal
          title="Active Orders"
          onClose={() => setViewOrders(false)}
          okText="Submit"
          cancelText="Cancel"
          modalBody={renderViewOrderModal()}
          isFooterVisible={false}
        />
      ) : null}
      {timeValid.isModalOpen ? (
        <Modal
          title="Outlet Not Open"
          onOk={() => {
            setTimeValid({
              ...timeValid,
              isModalOpen: false,
            });
          }}
          onClose={() =>
            setTimeValid({
              ...timeValid,
              isModalOpen: false,
            })
          }
          okText="Ok"
          modalBody={
            <div style={{ color: "tomato" }}>
              <h5>
                {rvcList[0]?.name} is not operational at the moment. Operating hours are{" "}
                <strong>
                  {rvcList[0]?.rvcStart_time?.split(":")?.slice(0, 2)?.join(":")}
                </strong>{" "}
                to{" "}
                <strong>
                  {rvcList[0]?.rvcStop_time?.split(":")?.slice(0, 2)?.join(":")}
                </strong>
                . Please contact a staff member for assistance.
              </h5>
            </div>
          }
          isFooterVisible={false}
        />
      ) : null}
      <div className="outer-cover">
        <div
          className="food-img-modal"
          style={
            showImage
              ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                width: "100%",
                height: "100%",
                background: "rgb(100 100 100 / 48%)",
                zIndex: 999,
              }
              : { display: "none" }
          }
        >
          <div className="moodal-content" onClick={() => setShowImage(null)}>
            <img
              src={showImage?.image}
              alt="Butter Chicken Combo"
              className="food-modal-img"
              title={showImage?.name || "No image for this item"}
            />
            <div className="close-btn" onClick={() => setShowImage(null)}>
              <svg
                viewPort="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  x1="1"
                  y1="11"
                  x2="11"
                  y2="1"
                  stroke="black"
                  strokeWidth="2"
                />
                <line
                  x1="1"
                  y1="1"
                  x2="11"
                  y2="11"
                  stroke="black"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
        {loaderItems.length ? <Loader /> : null}
        <div
          id="snackbar"
          className={`toaster-cover ${toasterData.type || ""} ${toasterData.type ? "show" : ""}`}
        >
          <span>{toasterData.message}</span>
        </div>
        <header style={{ background: "#466cf6" }}>
          <div className="navigation d-flex">
            <span
              className="d-flex"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            >
              <img
                src="/images/Wild-Wadi-Logo_white.png"
                alt="EZmenu.svg"
                style={{ width: "100px" }}
              />
            </span>
            <div className="d-flex align-items-center justify-content-center">
              <a
                href=""
                className="notification"
                onClick={(e) => {
                  e.preventDefault();
                  executeScroll();
                }}
                style={{ cursor: "default" }}
              >
                <span>{getTotal()}</span>
              </a>
            </div>
          </div>
        </header>

        <div className="container main-container">
          <div className="row">
            <FamilyGroups />
            <FamilyGroupDetails />
            <CartSection rvcRoom={rvcRoom} refelement={myRef} />
          </div>
        </div>
      </div>
    </AppContext.Provider>
  );
};

export default Index;